
import React from 'react';

const WhatsAppButton: React.FC = () => {
  const phone = "5491139416257";
  const message = "¡Hola! Quisiera recibir información sobre las soluciones digitales de LQP Global. 👋";
  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[9999] group flex items-center gap-3"
      aria-label="Contactar por WhatsApp"
    >
      {/* Label Tooltip */}
      <span className="bg-white text-black px-4 py-2 rounded-full text-xs font-bold shadow-2xl opacity-0 group-hover:opacity-100 transition-all transform translate-x-4 group-hover:translate-x-0 hidden md:block">
        ¿Hablamos?
      </span>
      
      {/* Icon Button */}
      <div className="w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-all duration-300 transform group-hover:scale-110 group-active:scale-95">
        <svg 
          className="w-8 h-8 fill-white" 
          viewBox="0 0 24 24"
        >
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.316 1.592 5.43 0 9.856-4.426 9.858-9.855.002-5.43-4.425-9.856-9.856-9.856-5.43 0-9.856 4.426-9.858 9.856-.001 1.938.529 3.754 1.534 5.344l-1.01 3.687 3.782-.992zm11.722-6.873c-.32-.16-1.89-.932-2.21-1.048-.32-.115-.553-.173-.785.173-.23.348-.892 1.102-1.096 1.334-.202.231-.406.26-.726.1-.319-.16-1.348-.497-2.569-1.585-.949-.845-1.59-1.888-1.776-2.199-.187-.311-.02-.479.14-.638.144-.143.32-.375.48-.563.16-.188.214-.32.32-.535.106-.215.053-.404-.026-.563-.08-.16-.785-1.892-1.076-2.589-.282-.676-.57-.585-.785-.595-.203-.01-.436-.011-.669-.011-.232 0-.61.087-.93.433-.32.348-1.221 1.196-1.221 2.915 0 1.719 1.25 3.379 1.425 3.61.174.231 2.458 3.754 5.957 5.266.832.359 1.481.574 1.985.734.835.266 1.596.228 2.197.138.67-.1 1.89-.773 2.158-1.479.267-.706.267-1.313.187-1.442-.08-.129-.294-.207-.614-.367z"/>
        </svg>
      </div>

      {/* Ripple Animation */}
      <div className="absolute inset-0 w-16 h-16 bg-[#25D366] rounded-full animate-ping opacity-20 pointer-events-none" />
    </a>
  );
};

export default WhatsAppButton;
